module.exports = __webpack_public_path__ + "img/3f540ce79023b45ebc82d07b3d2f40f0.jpg";